import { Button, Divider, HStack, VStack } from "@/shared/ui/primitives";
import { CardHeader } from "@/shared/ui/composites";
import { useTranslation } from "react-i18next";

export interface ErrorItem {
	title: string;
	description: string;
	/** 이동 버튼 클릭 시 이동할 URL. 있으면 <a>로 렌더해 브라우저가 직접 이동 (클릭 방해 방지) */
	url?: string | null;
	onMoveTo?: () => void;
}

export interface ErrorCardProps {
	errors: ErrorItem[];
	onRepair: () => void;
}

export const ErrorCard = (p: ErrorCardProps) => {
	const { t } = useTranslation();

	return (
		<VStack className="w-full px-[16px] py-[20px] rounded-[20px] gap-[20px] border border-outline bg-bg-weak/80 backdrop-blur-sm shadow-[0_8px_32px_rgba(15,23,42,0.06)]">
			<CardHeader
				title={t("workflow.errorCardTitle")}
				description={t("workflow.errorCardDescription")}
				buttonLabel={t("workflow.errorCardButtonLabel")}
				onBtnTap={p.onRepair}
			/>
			<Divider className="w-full" />
			{p.errors.map((item, i) => (
				<HStack className="w-full gap-[10px] p-[4px] items-start">
					<HStack className="w-[36px] h-[36px] rounded-[10px] bg-bg-regular text-ct-regular text-lg font-medium shrink-0">
						{i + 1}
					</HStack>
					<VStack className="w-full gap-[4px] items-start">
						<span className="text-ct-strong text-sm font-medium">{item.title}</span>
						<span className="text-ct-regular text-xs font-normal">{item.description}</span>
					</VStack>
					{item.onMoveTo ? (
						<Button variant="primary" size="sm" onClick={item.onMoveTo}>
							{t("workflow.moveto")}
						</Button>
					) : item.url ? (
						<Button
							variant="primary"
							size="sm"
							onClick={() => {
								sessionStorage.setItem("oauth_return_url", window.location.pathname);
								window.location.assign(item.url!);
							}}
						>
							{t("workflow.moveto")}
						</Button>
					) : null}
				</HStack>
			))}
		</VStack>
	);
};
